
<template>
  <div class="posterWrapper" :class="this.posterPosition">
    <ClassicPoster
      v-if="
        posterState.layout == 'classic-svg' ||
          posterState.layout == 'straight-svg'
      "
      :poster-state="posterState"
      :sound-data="soundData"
    />
  </div>
</template>

<script>
import ClassicPoster from '../components/posters/ClassicPoster'

export default {
  name: 'PosterContainer',
  props: {
    posterState: {
      type: Object,
      required: true,
    },
    soundData: {
      type: Object,
      required: true,
    },
    menuStep: {
      type: Number,
      required: false,
    },
    isMobile: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    ClassicPoster,
  },
  computed: {
    // on mobile make the poster non sticky in screen to enter dedication and in confirmation
    posterPosition() {
      return this.menuStep === 3 || this.menuStep === 5 ? 'relative' : 'sticky'
    },
  },
}
</script>

